import React, {useEffect, useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService";

import { useNavigate, NavLink, Navigate } from "react-router-dom";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";



const EstacionamientoPatente = () => {
    const navigate = useNavigate();
    const [patente, setPatente] = useState({patente: ""});
    const [patenteM, setPatenteM] = useState({patente:""});
    const [errorMessage, setErrorMessage] = useState("");
    const [patentesLoaded, setPatentesLoaded] = useState(false);
    const [open, setOpen] = useState(false);
    const [listaPatentes, setListaPatentes] = useState({})
   
    const handleOpen = () => {
      setOpen(!open);
    };

    useEffect(()=>{
        loadPatentes();
    },[])

    const loadPatentes = () => {
        EstacionamientoService.cargarPatentes(localStorage.getItem("estacionamiento_celular"),localStorage.getItem("estacionamiento_token"))
            .then((resp)=> {
                setListaPatentes(resp.data.extra);
                setPatentesLoaded(true);
                console.log(resp.data.extra.patentes.length);
                if (resp.data.extra.patentes.length>0) {
                    setPatente({patente: resp.data.extra.patentes[0].patente});}
            })
            .catch(()=>{setListaPatentes({patentes:[]});
        setPatentesLoaded(true)})
    }

    const hideFooter = () => {
        document.getElementsByTagName("footer")[0].style.visibility='hidden'
      }

      const showFooter = () => {
        document.getElementsByTagName("footer")[0].style.visibility='visible'
      }

const changeDdlHandler = (e) =>{
    setPatente({patente: e.target.value});
}

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setPatente({
          ...patente,
          [name]: value,
        });
        
      };

      const changeHandlerM = (e) => {
        const { name, value } = e.target;
        setPatenteM({
          ...patenteM,
          [name]: value,
        });
        
      };

    const continueHandler = () => {
        const regex = /^([a-zA-Z]{3})([0-9]{3})$/i;
        const regex2 = /^([a-zA-Z]{2})([0-9]{3})([a-zA-Z]{2})$/i;
        if (listaPatentes.patentes.map(x=>x.patente).indexOf(patenteM.patente.toUpperCase())!=-1)
            setErrorMessage("La patente ya existe");
        else
            
        if (patente.patente=="" && !regex.test(patenteM.patente) && !regex2.test(patenteM.patente)){
            setErrorMessage("Se debe ingresar una patente válida");
        } else {
        if (patente.patente==""){
            localStorage.setItem("estacionamiento_patente", patenteM.patente.toUpperCase());  
            EstacionamientoService.agregarPatente(localStorage.getItem("estacionamiento_celular"), localStorage.getItem("estacionamiento_token"),
            patenteM.patente.toUpperCase());  
        } else {
            localStorage.setItem("estacionamiento_patente", patente.patente); 
        }
        navigate("/estacionamientolugar");
        }
    }

    return (
        <>
       <div class="container text-center estacionamientoContent" >
       <EstacionamientoSmallHeader texto="" retorno="/estacionamiento"/>
       <div class="row">
                <div class="col">
                <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/estacionamiento")}}/>
                        <img src="./estacionamient-inicio-1.png"  class="imgSubtitleMain" ></img>
                   
                </div>
        </div>
       <div class="row">
            <div class="col">
                <h1> Selecciona tu patente</h1>
            </div>
        </div>
        <div class="row">
            <div class="col">
       


{patentesLoaded?

            <select class="selectInput" value={patente.patente} onChange={changeDdlHandler}>
<option value={""}> Patente nueva</option>
{listaPatentes.patentes.map((option) => (

  <option value={option.patente}>{option.patente}</option>

))}

</select>
:"Cargando..."
}
            </div>
        </div>{patente.patente==""?
        <div class="row">
            <div class="col">
                <input type="text" name="patente" 
                className="inputText" value={patenteM.patente} onChange={changeHandlerM} onFocus={hideFooter} onBlur={showFooter}></input>
            </div>
        </div>:""}
        <div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonRegularClip" onClick={continueHandler}>Siguiente</button>
                    </div>
                </div>
            </div>
           
        </div>
        <p class="errorText" align="center">{errorMessage}</p>
        
        
        </>

    );
    }
export default EstacionamientoPatente;